module.exports = __webpack_public_path__ + "img/etn.bb77c713.svg";